import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PdfEditState {
  pdfUrl: string | null;
  fileId: number | null;
}

const initialState: PdfEditState = {
  pdfUrl: null,
  fileId: null
};

const pdfEditSlice = createSlice({
  name: 'pdfEdit',
  initialState,
  reducers: {
    setPdfForEditing: (state, action: PayloadAction<{url: string, fileId: number}>) => {
      state.pdfUrl = action.payload.url;
      state.fileId = action.payload.fileId;
    },
    clearPdfForEditing: (state) => {
      state.pdfUrl = null;
      state.fileId = null;
    }
  }
});

export const { setPdfForEditing, clearPdfForEditing } = pdfEditSlice.actions;
export default pdfEditSlice.reducer; 